import { Input } from "antd";
import { Plus, X } from "lucide-react";
import { nanoid } from "nanoid";
import { RESUME_SECTION_TYPES } from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";

const { TextArea } = Input;

const blankItem = () => ({
  id: `pub-${nanoid(6)}`,
  title: "",
  publisher: "",
  date: "",
  url: "",
  authors: "",
  description: "",
});

export default function Publications({
  id,
  data,
  onChange,
  onDelete,
  allCollapsed,
}) {
  const items = data ?? [];

  const updateItem = (idx, patch) => {
    onChange(items.map((it, i) => (i === idx ? { ...it, ...patch } : it)));
  };

  const removeItem = (idx) => {
    onChange(items.filter((_, i) => i !== idx));
  };

  const addItem = () => {
    onChange([...items, blankItem()]);
  };

  return (
    <SectionCardShell
      id={id}
      type={RESUME_SECTION_TYPES.PUBLICATIONS}
      data={data}
      onChange={onChange}
      onDelete={onDelete}
      allCollapsed={allCollapsed}
    >
      <div className="flex flex-col gap-4">
        {items.map((it, idx) => (
          <div
            key={it.id}
            className="border border-gray-200 rounded-lg p-3 bg-gray-50/40"
          >
            <div className="flex justify-between items-start mb-2">
              <p className="font-medium text-sm text-[#344054]">
                {it.title || `Publication #${idx + 1}`}
              </p>
              <button
                onClick={() => removeItem(idx)}
                className="text-gray-400 hover:text-red-600"
              >
                <X size={16} />
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Input
                placeholder="Title"
                value={it.title}
                onChange={(e) => updateItem(idx, { title: e.target.value })}
              />
              <Input
                placeholder="Publisher / Journal"
                value={it.publisher}
                onChange={(e) => updateItem(idx, { publisher: e.target.value })}
              />
              <Input
                placeholder="Date (YYYY-MM)"
                value={it.date}
                onChange={(e) => updateItem(idx, { date: e.target.value })}
              />
              <Input
                placeholder="URL / DOI"
                value={it.url}
                onChange={(e) => updateItem(idx, { url: e.target.value })}
              />
              <Input
                placeholder="Authors (comma-separated)"
                value={it.authors}
                onChange={(e) => updateItem(idx, { authors: e.target.value })}
              />
              <div className="col-span-2">
                <TextArea
                  placeholder="Abstract / Description (optional)"
                  value={it.description}
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  onChange={(e) =>
                    updateItem(idx, { description: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
        ))}
        <button
          onClick={addItem}
          className="self-start flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700"
        >
          <Plus size={14} /> Add publication
        </button>
      </div>
    </SectionCardShell>
  );
}
